import { useRouter } from 'next/router';
import { useEffect } from 'react';

import { Routes } from 'constants/routes.constants';
import { useStorageState } from 'hooks/useStorageState';

const SAUDI_REWARDS_REDEEM_TOKEN = 'SaudiRewardsRedeemToken';

export const useSessionRedeemToken = () => {
  const { query, isReady, replace } = useRouter();
  const queryRedeemToken = query['redeem_token'] as string;
  const [redeemToken, setRedeemToken] = useStorageState(
    SAUDI_REWARDS_REDEEM_TOKEN,
    {
      defaultValue: '',
      engine: 'localStorage',
    },
  );

  useEffect(() => {
    if (isReady && !!queryRedeemToken) {
      replace(
        {
          pathname: Routes.SaudiRewardsRetroRedeem,
        },
        undefined,
        { shallow: true },
      );
      if (redeemToken !== queryRedeemToken) setRedeemToken(queryRedeemToken);
    }
  }, [isReady, queryRedeemToken, redeemToken, replace, setRedeemToken]);

  return redeemToken || queryRedeemToken;
};
